<script setup lang="ts">
import HomeHeader from "@/components/layout/headers/HomeHeader.vue";
import HomeFooter from "@/components/layout/footers/HomeFooter.vue";
</script>

<template>
  <div class="home-layout">
    <HomeHeader />
    <main class="home-layout__content">
      <slot />
    </main>
    <HomeFooter />
  </div>
</template>

<style scoped>
.home-layout {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: rgba(245, 245, 247, 1);
}

.home-layout__content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}
</style>

